import React from "react";
import PropTypes from "prop-types";

/**
 * Brand loading spinner for the Lead Summary module (16-dot ring).
 * Pair with a context-specific message (e.g. "Regenerating summary...").
 */
export function LeadLoadingSpinner({
    message = "",
    className = "",
    size = "md",
    overlay = false,
    page = false
}) {
    const rootClass = [
        "lead-loading-spinner",
        `lead-loading-spinner--${size}`,
        page ? "lead-loading-spinner--page" : "",
        !page && overlay ? "lead-loading-spinner--overlay" : "",
        className
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={rootClass} role="status" aria-live="polite" aria-busy="true">
            <svg
                className="lead-loading-spinner__ring"
                width="28"
                height="30"
                viewBox="0 0 28 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <circle cx="14.8651" cy="2.41975" r="2.41975" fill="#1C2B2A" />
                <circle cx="9.85238" cy="3.62973" r="2.24691" fill="#063820" />
                <circle cx="5.70298" cy="6.22202" r="2.07407" fill="#1A5F4F" />
                <circle cx="2.59264" cy="10.5433" r="1.90123" fill="#1F6F5C" />
                <circle cx="1.7284" cy="15.5555" r="1.7284" fill="#159152" />
                <circle cx="2.93837" cy="20.5678" r="1.55556" fill="#25B36B" />
                <circle cx="5.53115" cy="24.8891" r="1.38272" fill="#4DC98A" />
                <circle cx="9.85246" cy="27.8271" r="1.20988" fill="#8ADEB1" />
                <circle cx="15.038" cy="28.5185" r="1.20988" fill="#8ADEB1" />
                <circle cx="19.8759" cy="27.8271" r="1.20988" fill="#C6F0D8" />
                <circle cx="23.8515" cy="24.8891" r="1.03704" fill="#C6F0D8" />
                <circle cx="26.4443" cy="20.5678" r="0.864198" fill="#D9F8E7" />
                <circle cx="27.1357" cy="15.7285" r="0.864198" fill="#D9F8E7" />
                <circle cx="26.0986" cy="10.8891" r="0.864198" fill="#CBFFCA" />
                <circle cx="23.8515" cy="7.25923" r="0.691358" fill="#E2FFE2" />
                <circle cx="20.5673" cy="4.66647" r="0.518519" fill="#EDFFF5" />
            </svg>
            {message ? <span className="lead-loading-spinner__message">{message}</span> : null}
        </div>
    );
}

LeadLoadingSpinner.propTypes = {
    message: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.oneOf(["sm", "md"]),
    overlay: PropTypes.bool,
    page: PropTypes.bool
};
